import { createApp } from 'vue'
import NewCarLoanCalculatorSummary from './NewCarLoanCalculatorSummary'
import handleComponentProps from '../../../../foundation/js/utils/handleComponentProps.js'

const el = '.nyk-component--new-car-loan-calculator-summary'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((NewCarLoanCalculatorSummaryDOM) => {
            const props = handleComponentProps(NewCarLoanCalculatorSummary, NewCarLoanCalculatorSummaryDOM)
            const component = createApp(NewCarLoanCalculatorSummary, props).use(Store)
            component.mount(NewCarLoanCalculatorSummaryDOM)
        })
    }
}
